import React from "react";
import { Check, CheckCheck } from "lucide-react";

/**
 * WhatsApp-style delivery status indicator for outgoing messages.
 * - "sent"      → 1 grey check   (created, not delivered to others)
 * - "delivered" → 2 grey checks  (received by all other participants but not yet read)
 * - "read"      → 2 blue checks  (read by all other participants)
 */
export function computeStatus(message, myId, otherIds) {
  if (!message || message.sender_id !== myId) return null;
  if (!otherIds || otherIds.length === 0) return "sent";
  const readBy = new Set(message.read_by || []);
  const deliveredTo = new Set(message.delivered_to || []);
  const allRead = otherIds.every((id) => readBy.has(id));
  if (allRead) return "read";
  const allDelivered = otherIds.every((id) => deliveredTo.has(id));
  if (allDelivered) return "delivered";
  return "sent";
}

export default function MessageStatus({ status, tone = "light" }) {
  if (!status) return null;
  const isRead = status === "read";
  const isDouble = status === "delivered" || status === "read";
  const label = { sent: "Inviato", delivered: "Consegnato", read: "Letto" }[status];
  // tone "light" = message bubble is dark (mine), tone "dark" = light bubble
  const grey = tone === "light" ? "text-white/70" : "text-slate-400";
  const blue = tone === "light" ? "text-sky-300" : "text-[#1E3A8A]";
  const color = isRead ? blue : grey;
  const Icon = isDouble ? CheckCheck : Check;
  return (
    <span title={label} aria-label={label}
          data-testid={`msg-status-${status}`}
          className={`inline-flex items-center ${color}`}>
      <Icon className="h-3.5 w-3.5" strokeWidth={2.5} />
    </span>
  );
}
